"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableDownloadESIM = exports.enablePayPalAutoPayPostpaid = exports.enablePayPalAutoPayPrepaid = exports.ExtoleRefferalTags = exports.ExtoleReferralIds = exports.subStatusOrder = exports.AccountStatus = exports.OfferingIds = exports.LOB = exports.ClientName = exports.FiberhoodType = exports.CompanyName = exports.bankAccountTypes = exports.SubGroups = exports.creditCardNumberFormats = exports.creditCardMaskFourFiveSix = exports.creditCardMaskFourSixFour = exports.creditCardMaskFourFourFourFourThree = exports.creditCardMaskFourFourFive = exports.creditCardMaskSixThirteen = exports.creditCardMaskFourSixFive = exports.creditCardMaskFourFourFourFour = exports.creditCardTypes = exports.appointmentFormats = exports.genericCustomerReferralEndpoint = exports.genericContentUrl = exports.genericContentBulkUrl = exports.momentFormats = exports.zipcodesListFor5G = exports.meteredPlanIds = exports.ParentPage = exports.UserRole = exports.disableCallForwardingComponent = exports.zyxelWiFiRouter = exports.eastZone = exports.homeServiceVPType = exports.plumeComponentCode = exports.addOnServicesPrefix = exports.includedServicesPrefix = exports.subscriptionBilling = exports.sbiType = exports.homeServiceType = exports.ownerType = exports.ppTenantType = exports.tenantType = void 0;
exports.tenantType = 'MDU_HS_RESIDENT_AP';
exports.ppTenantType = 'MDU_HS_RESIDENT_PP';
exports.ownerType = 'MDU_OWNER';
exports.homeServiceType = 'HOME_SERVICE';
exports.sbiType = 'BUS_HOME';
exports.subscriptionBilling = 'SB_HOME';
exports.includedServicesPrefix = 'MDU_OWNER';
exports.addOnServicesPrefix = 'RESIDENT';
exports.plumeComponentCode = 'WIFI_PLUME_1SUPERPOD';
exports.homeServiceVPType = 'HOME_SERVICES_VP';
exports.eastZone = 'EAST_TROY';
exports.zyxelWiFiRouter = 'WIFI_ROUTER_ZYXEL';
exports.disableCallForwardingComponent = true;
var UserRole;
(function (UserRole) {
    UserRole["ACCOUNT_PRIMARY"] = "Account Primary";
    UserRole["IT_SUPPORT"] = "IT Support";
    UserRole["BILL_VIEWER"] = "Bill Viewer";
    UserRole["NO_ROLE"] = "No Role";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var ParentPage;
(function (ParentPage) {
    ParentPage["upgradeServicesPage"] = "UPGRADE_SERVICE";
    ParentPage["dashboardPage"] = "HS_DASHBOARD";
    ParentPage["billingPage"] = "HS_BILLING";
})(ParentPage = exports.ParentPage || (exports.ParentPage = {}));
;
exports.meteredPlanIds = ['CDMA 700 ANYTIME MIN', 'CDMA 700 SHARE', 'CDMA FAM SHARE', 'CDMA FIC 300 SHARE', 'CI300', 'MS_GOV_125', 'MS_GOV_NW_125',
    'NW_B2B_500_MIN_POOL', 'NW_B2B_FEA_SHAR_DATA', 'NW_B2B_FEATURE_PHONE', 'NW_BUSINESS_POOL_500', 'NW_FAMILY_700_PLAN', 'NW_NONPDA_CHILD', 'NW_PDA_CHILD_VS2',
    'NW_SHARE_ADD', 'NW_SHARED_PHONE', 'NW_TALK_400_SHARE', 'NW_TALK_MSG_250', 'NW_TALK_MSG_500', 'NW_TEXT_PLAN', 'NW_WB_MS_1000_VS2', 'NW_WB_MS_500_VS2',
    'NW_WEB_MSG_1000', 'NW_WEB_MSG_1000_PLUS', 'NW_WEB_MSG_500'];
exports.zipcodesListFor5G = ['39601', '39602', '39603', '39701', '39702', '39703', '39704', '39705', '39540', '39501', '39502', '39503', '39505', '39506', '39507',
    '39401', '39402', '39403', '39404', '39406', '39407', '39560', '39110', '39130', '39157', '39158'];
exports.momentFormats = {
    day: 'YYYYMMDD',
    loadedMonth: 'YYYYMM'
};
exports.genericContentBulkUrl = '/rest-api/genericContent/v1/contentText';
exports.genericContentUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=';
exports.genericCustomerReferralEndpoint = '/rest-api/homeservices/v1/customerreferral';
exports.appointmentFormats = {
    timeFormat: 'h:mm a',
    timeFormat_A: 'h:mm A',
    dayFormat: 'D',
    FullDayFormat: 'MMMM D, YYYY',
    MonthYearFormat: 'MMMM YYYY',
    startTimeFormat: 'dddd, MMMM D, YYYY',
};
var creditCardTypes;
(function (creditCardTypes) {
    creditCardTypes["masterCard"] = "MASTER_CARD";
    creditCardTypes["americanExpress"] = "AMERICAN_EXPRESS";
    creditCardTypes["visa"] = "VISA";
    creditCardTypes["discover"] = "DISCOVER";
})(creditCardTypes = exports.creditCardTypes || (exports.creditCardTypes = {}));
// -----------------------------------------------------------------------------
// Credit Card Number Formats
// -----------------------------------------------------------------------------
// VISA, VISA Electron, China UnionPay, MasterCard, Maestro, Diners Club, Discover, JCB, Dankort, InterPayment
exports.creditCardMaskFourFourFourFour = '0000 0000 0000 0000';
// American Express, Maestro
exports.creditCardMaskFourSixFive = '0000 000000 00000';
// China UnionPay
exports.creditCardMaskSixThirteen = '000000 0000000000000';
// Maestro
exports.creditCardMaskFourFourFive = '0000 0000 00000';
// Maestro
exports.creditCardMaskFourFourFourFourThree = '0000 0000 0000 0000 000';
// Diners Club
exports.creditCardMaskFourSixFour = '0000 000000 0000';
// UATP
exports.creditCardMaskFourFiveSix = '0000 00000 000000';
// Credit Card Number Formats
exports.creditCardNumberFormats = [
    {
        cardType: 'VISA',
        cardIINRanges: ['4', '4026', '417500', '4405', '4508', '4844', '4913', '4917'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: '/resources/images/card-icons/checkout/Visa.svg'
    },
    {
        cardType: 'AMEX',
        cardIINRanges: ['34', '37'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourSixFive,
            cardNumberLength: 15
        },
        cardIcon: '/resources/images/card-icons/checkout/Amex.svg'
    },
    {
        cardType: 'CHINA_UNIONPAY',
        cardIINRanges: ['62'],
        cardSpacingPatterns: {
            cardSpacingPattern: `${exports.creditCardMaskFourFourFourFour}||${exports.creditCardMaskSixThirteen}`,
            cardNumberLength: 19
        },
        cardIcon: ''
    },
    {
        cardType: 'MASTER_CARD',
        cardIINRanges: ['51-55', '222100-272099'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: '/resources/images/card-icons/checkout/Mastercard.svg'
    },
    {
        cardType: 'MAESTRO',
        cardIINRanges: ['500000-509999', '560000-589999', '600000-699999'],
        cardSpacingPatterns: {
            cardSpacingPattern: `${exports.creditCardMaskFourFourFive}||${exports.creditCardMaskFourSixFive}||${exports.creditCardMaskFourFourFourFour}||${exports.creditCardMaskFourFourFourFourThree}`,
            cardNumberLength: 19
        },
        cardIcon: ''
    },
    {
        cardType: 'DINERS_CLUB_INTERNATIONAL',
        cardIINRanges: ['300-305', '309', '36', '38-39'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourSixFour,
            cardNumberLength: 14
        },
        cardIcon: ''
    },
    {
        cardType: 'DINERS_CLUB_NORTH_AMERICA',
        cardIINRanges: ['54', '55'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: ''
    },
    {
        cardType: 'DISCOVER',
        cardIINRanges: ['6011', '622126-622925', '644-649', '65'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: '/resources/images/card-icons/checkout/Discover.svg'
    },
    {
        cardType: 'JCB',
        cardIINRanges: ['3528-3589'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: ''
    },
    {
        cardType: 'UATP',
        cardIINRanges: ['1'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFiveSix,
            cardNumberLength: 15
        },
        cardIcon: ''
    },
    {
        cardType: 'DANKORT',
        cardIINRanges: ['5019'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: ''
    },
    {
        cardType: 'INTER_PAYMENT',
        cardIINRanges: ['636'],
        cardSpacingPatterns: {
            cardSpacingPattern: exports.creditCardMaskFourFourFourFour,
            cardNumberLength: 16
        },
        cardIcon: ''
    }
];
var SubGroups;
(function (SubGroups) {
    SubGroups["HS_SBI_PHONE"] = "HS_SBI_PHONE";
    SubGroups["INTERNET_STATIC_IP"] = "INTERNET_STATIC_IP";
    SubGroups["INTERNET_SBI_ROUTER"] = "INTERNET_SBI_ROUTER";
    SubGroups["ADDON"] = "ADDON";
})(SubGroups = exports.SubGroups || (exports.SubGroups = {}));
;
exports.bankAccountTypes = [
    {
        text: 'Checking',
        value: 'checking'
    },
    {
        text: 'Savings',
        value: 'savings'
    },
];
var CompanyName;
(function (CompanyName) {
    CompanyName["HARBOR"] = "Harbor";
})(CompanyName = exports.CompanyName || (exports.CompanyName = {}));
var FiberhoodType;
(function (FiberhoodType) {
    FiberhoodType["MDU_NONBULK"] = "MDU_NONBULK";
    FiberhoodType["MDU_BULK"] = "MDU_BULK";
    FiberhoodType["SFU_BULK"] = "SFU_BULK";
    FiberhoodType["MDU_HOSPITALITY"] = "MDU_HOSPITALITY";
    FiberhoodType["FTTH"] = "FTTH";
})(FiberhoodType = exports.FiberhoodType || (exports.FiberhoodType = {}));
var ClientName;
(function (ClientName) {
    ClientName["MMA"] = "MMA";
})(ClientName = exports.ClientName || (exports.ClientName = {}));
var LOB;
(function (LOB) {
    LOB["WIRELESS"] = "WIRELESS";
    LOB["FIBER"] = "FIBER";
})(LOB = exports.LOB || (exports.LOB = {}));
var OfferingIds;
(function (OfferingIds) {
    OfferingIds["INTERNET"] = "INTERNET";
    OfferingIds["TV"] = "TV";
    OfferingIds["PHONE"] = "PHONE";
    OfferingIds["TV2"] = "TV2";
})(OfferingIds = exports.OfferingIds || (exports.OfferingIds = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["INACTIVE"] = "INACTIVE";
    AccountStatus["FINAL"] = "FINAL";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
exports.subStatusOrder = {
    'ACTIVE': 1,
    'PENDING': 2,
    'INACTIVE': 3,
    'HOTLINED': 4
};
// -----------------------------------------------------------------------------
// Extole Constants
// -----------------------------------------------------------------------------
var ExtoleReferralIds;
(function (ExtoleReferralIds) {
    ExtoleReferralIds["WIRELESS_DASHBOARD"] = "refer_wireless_dashboard";
    ExtoleReferralIds["WIRELESS_OVERLAY"] = "refer_wireless_overlay";
})(ExtoleReferralIds = exports.ExtoleReferralIds || (exports.ExtoleReferralIds = {}));
var ExtoleRefferalTags;
(function (ExtoleRefferalTags) {
    ExtoleRefferalTags["WIRELESS_DASHBOARD_TAG"] = "extole_zone_refer_wireless_dashboard";
    ExtoleRefferalTags["WIRELESS_OVERLAY_TAG"] = "extole_zone_refer_wireless_overlay";
})(ExtoleRefferalTags = exports.ExtoleRefferalTags || (exports.ExtoleRefferalTags = {}));
// -----------------------------------------------------------------------------
// PayPal AutoPay
// -----------------------------------------------------------------------------
exports.enablePayPalAutoPayPrepaid = false; // Enables or disables the PayPal AutoPay Prepaid option
exports.enablePayPalAutoPayPostpaid = true; // Enables or disables the PayPal AutoPay Postpaid option
// -----------------------------------------------------------------------------
// ESIM
// -----------------------------------------------------------------------------
exports.enableDownloadESIM = false; // Temporarily disable ESIM download STRY0018578
//# sourceMappingURL=constants.js.map